export function getCurrentEnvironment(): string {
  const env = window.location.hostname;
  let returnEnv: string;
  if (env.includes("-dev")) {
    returnEnv = "dev";
  } else if (env.includes("-qa")) {
    returnEnv = "qa";
  } else if (env.includes("-stg")) {
    returnEnv = "stg";
  } else if (env.includes("-pmodstg")) {
    returnEnv = "pmod-stg";
  } else if (env.includes("local")) {
    returnEnv = "dev";
  } else {
    returnEnv = "production";
  }
  return returnEnv;
}


export const environment: string = getCurrentEnvironment();
